import React, { useState } from 'react';
import PropTypes from 'prop-types';
import MaterialIcon from './MaterialIcon';
import './EasyButton.css';

const EasyButton = ({
  children,
  onClick,
  icon,
  iconSize = 20,
  disabled = false,
  size = 'medium', // 'small', 'medium', 'large'
  className = '',
  ...props
}) => {
  const [isPressed, setIsPressed] = useState(false);

  const handleMouseDown = () => {
    if (!disabled) {
      setIsPressed(true);
    }
  };

  const handleMouseUp = () => {
    setIsPressed(false);
  };

  const handleMouseLeave = () => {
    setIsPressed(false);
  };

  const handleClick = (e) => {
    if (!disabled && onClick) {
      onClick(e);
    }
  };

  return (
    <button
      className={`easy-button ${size} ${isPressed ? 'pressed' : ''} ${disabled ? 'disabled' : ''} ${className}`}
      onClick={handleClick}
      onMouseDown={handleMouseDown}
      onMouseUp={handleMouseUp}
      onMouseLeave={handleMouseLeave}
      disabled={disabled}
      {...props}
    >
      <div className="easy-button-content">
        {icon && <MaterialIcon icon={icon} size={iconSize} className="easy-button-icon" />}
        <span className="easy-button-text">{children}</span>
      </div>
    </button>
  );
};

EasyButton.propTypes = {
  children: PropTypes.node,
  onClick: PropTypes.func,
  icon: PropTypes.string,
  iconSize: PropTypes.number,
  disabled: PropTypes.bool,
  size: PropTypes.oneOf(['small', 'medium', 'large']),
  className: PropTypes.string,
};

export default EasyButton;
